import { initialiseSwapTopup, initialiseSwapWithdrawal, useWLOrderFormDispatch } from '@talos/kyoko';
import { useNavigate } from 'react-router-dom';
import { GCashButton } from './Button';

export const WalletFlowButtons = (props: { renderTopUp?: boolean; renderWithdrawal?: boolean }) => {
  const { renderTopUp = true, renderWithdrawal = true } = props;
  const navigate = useNavigate();
  const dispatch = useWLOrderFormDispatch();
  return (
    <div className="mt-2 flex justify-between gap-2">
      {renderTopUp && (
        <GCashButton
          size="md"
          variant="primary"
          data-testid="top-up-button"
          onClick={() => {
            dispatch(initialiseSwapTopup());
            navigate('cash');
          }}
        >
          Top Up
        </GCashButton>
      )}
      {renderWithdrawal && (
        <GCashButton
          size="md"
          variant="secondary"
          data-testid="withdraw-button"
          onClick={() => {
            dispatch(initialiseSwapWithdrawal());
            navigate('cash');
          }}
        >
          Withdraw
        </GCashButton>
      )}
    </div>
  );
};
